import React from 'react'
import { useForm } from 'react-hook-form'
import { zodResolver } from '@hookform/resolvers/zod'
import { z } from 'zod'
import { useSelector } from 'react-redux'
import { Icon } from '@iconify/react'
import { MICROSOFT_365_OAUTH_LOGIN_URI } from '../../../env'
import { showErrorToast } from '../../../utils/showToast'
import AuthInput from './AuthInput'
import { Button } from '../../../components/ui/legacy'
import useLoginMutation from '../hooks/useLoginMutation'

const loginSchema = z.object({
  email: z.string().min(1, 'Vui lòng nhập tài khoản'),
  // .email('Tài khoản không hợp lệ'),
  password: z.string().min(1, 'Vui lòng nhập mật khẩu'),
})

function LoginForm() {
  const { isLoading } = useSelector((state) => state.auth.data)
  const { loginMutation } = useLoginMutation()
  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: zodResolver(loginSchema),
    defaultValues: {
      email: '',
      password: '',
    },
  })

  const signInHandler = (data) => {
    loginMutation.mutate({
      email: data.email,
      password: data.password,
    })
  }

  const signIn365Handler = () => {
    window.location.assign(MICROSOFT_365_OAUTH_LOGIN_URI)
  }

  const errorOnclick = () => {
    showErrorToast({ message: 'Sẽ được cập nhật trong phiên bản tới' })
  }

  return (
    <div className="grid w-[330px] grid-cols-1 gap-3 sm:w-[380px]">
      <form
        className="grid grid-cols-1 gap-8"
        onSubmit={handleSubmit(signInHandler)}
      >
        <AuthInput
          control={control}
          name="email"
          placeholder="Nhập tên tài khoản"
          // type="email"
          error={errors.email?.message}
        />
        <AuthInput
          control={control}
          name="password"
          placeholder="Nhập mật khẩu"
          type="password"
          error={errors.password?.message}
        />
        <Button
          type="submit"
          className="gap-1 sm:text-lg"
          size="py-3 px-4"
          rounded="lg"
          variant="primary"
          disabled={isLoading}
        >
          Đăng nhập
        </Button>
      </form>
      <div className="mx-auto my-4 w-10 border-2 border-t border-gray-secondary" />
      <Button
        className="gap-1 sm:text-lg"
        onClickHandler={signIn365Handler}
        size="py-3 px-4"
        rounded="lg"
        variant="super"
        fullWidth
        disabled={isLoading}
      >
        <Icon icon="prime:microsoft" className="text-3xl" />
        Đăng nhập với tài khoản Microsoft
      </Button>
      <p
        className="text-md cursor-pointer text-center font-semibold text-gray-secondary underline hover:text-gray-accent"
        onClick={errorOnclick}
      >
        Báo lỗi
      </p>
    </div>
  )
}

export default LoginForm
